import React, { useState } from "react";
import NewsLetter from "../ui/NewsLetter";
import footer from "../../assets/footerbgimg.webp";
import { IoCall } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { AiFillHeart } from "react-icons/ai";
import { Link } from "react-router-dom";

function Footer() {
  const [like, setLike] = useState(false);
  return (
    <>
      <div>
        <NewsLetter />
        <footer
          className='text-white/60 w-auto h-[auto] sm:h-screen'
          style={{
            backgroundImage: `url(${footer})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className='w-full h-full flex justify-center items-center customBackgroundfooterSection'>
            <div>
              <div className='px-5 sm:px-7 lg:px-14 xl:px-48 pt-24 sm:pt-0 overflow-hidden grid grid-cols-1 sm:grid-cols-4 gap-5 sm:gap-16'>
                {/* Remedic */}
                <div>
                  <h1 className='text-xl text-white pb-12'>Remedic</h1>
                  <p className='leading-7 text-white/75'>
                    Far far away, behind the word mountains, far from the
                    countries Vokalia and Consonantia, there live the blind
                    texts.
                  </p>
                </div>
                {/* Information */}
                <div>
                  <h1 className='text-xl text-white pb-12'>Information</h1>
                  <ul>
                    <li>Appointments</li>
                    <li>Our Specialties</li>
                    <li>Why Choose us</li>
                    <li>Our Services</li>
                    <li>Health Tips</li>
                  </ul>
                </div>
                {/* Site Links */}
                <div>
                  <h1 className='text-xl text-white pb-12'>Site Links</h1>
                  <ul>
                    <li>
                      <Link to='/'>Home</Link>
                    </li>
                    <li>
                      <Link to='/about'>About</Link>
                    </li>
                    <li>
                      <Link to='/departments'>Departments</Link>
                    </li>
                    <li>
                      <Link to='/doctors'>Doctors</Link>
                    </li>
                    <li>
                      <Link to='/blog'>Blog</Link>
                    </li>
                    <li>
                      <Link to='/contact'>Contact</Link>
                    </li>
                  </ul>
                </div>
                {/* Have a Questions? */}
                <div>
                  <h1 className='text-xl text-white pb-12'>
                    Have a Questions?
                  </h1>
                  <div>
                    <div className='flex items-center gap-2 pb-5'>
                      <div>
                        <FaLocationDot className='text-xl fill-white/85' />
                      </div>
                      <div>
                        <p>
                          203 Fake St. Mountain View, San Francisco, California,
                          USA
                        </p>
                      </div>
                    </div>
                    <div className='flex items-center gap-2 pb-5'>
                      <div>
                        <IoCall className='text-xl fill-white' />
                      </div>
                      <div>
                        <a
                          href='tel:+91 3923929210'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          +91 392 3929 210
                        </a>
                      </div>
                    </div>
                    <div className='flex items-center gap-2 pb-5'>
                      <div>
                        <IoMdMail className='text-xl fill-white' />
                      </div>
                      <div>
                        <a
                          href='mailto:info@yourdomain.com?subject=Enter%20Subject%20Please&body=Enter%20your%20query%0a%0a'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          info@yourdomain.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p className='text-center text-white/75 sm:pt-24 py-20 sm:py-0 fill-red-500'>
                Copyright ©2024 All rights reserved | This template is made with
                by{" "}
                <span
                  onClick={() => setLike(!like)}
                  className=' cursor-pointer'
                >
                  <AiFillHeart
                    className={`inline ${like ? "fill-red-500" : "fill-white"}`}
                  />{" "}
                  Inflection org
                </span>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;
